// @flow
import * as React from 'react';
import { optimizelyService } from './optimizelyService';

export type Props = {
  children: React.Node,
  optimizely?: Object
};

const OptimizelyContext = React.createContext<any>();

function OptimizelyProvider({
  optimizely = optimizelyService.create(window.optimizely),
  children
}: Props) {
  return (
    <OptimizelyContext.Provider value={{ optimizely }}>
      {children}
    </OptimizelyContext.Provider>
  );
}

// TODO: Move to a utilities file & rename this file to OptimizelyProvider
function useOptimizely() {
  const context = React.useContext(OptimizelyContext);
  if (context === undefined) {
    throw new Error('useOptimizely must be used within a OptimizelyProvider');
  }
  return context;
}

export { OptimizelyProvider, useOptimizely };
